import { render } from "./Flag.vue?vue&type=template&id=4accc944"
import script from "./Flag.vue?vue&type=script&lang=js"
export * from "./Flag.vue?vue&type=script&lang=js"

import exportComponent from "/home/annex/www/kamminga-wagtail/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__